import { Grid, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/styles";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import Timeline from "../CandidateDetails/Timeline";
import CandidateAssessment from "./CandidateAssessment";
import CandidateInterview from "./CandidateInterview";
import TabPanel from "./TabPanel";

type Props = {
  candidate?: CandidateDetails;
  job?: JobRequestDetails;
};
function tabAriaProps(index: number) {
  return {
    id: `candidate-tab-${index}`,
    "aria-controls": `candidate-tabpanel-${index}`,
  };
}

function tabPanelAriaProps(index: number) {
  return {
    id: `candidate-tabpanel-${index}`,
    "aria-labelledby": `candidate-tab-${index}`,
  };
}

const CustomTab = styled(Tab)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  color: "#0F1829",
  textTransform: "none",
  letterSpacing: "0.1px",
}));

const Container = ({ candidate, job }: Props) => {
  const [tabValue, setTabValue] = useState<number>(0);
  const handleTabChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    },
    [],
  );
  const [params] = useSearchParams();
  const stage = params.get("stage") || "";

  useEffect(() => {
    if (stage.includes("technicalAssessment")) {
      setTabValue(1);
    }
  }, [stage]);
  return (
    <Grid container direction={"column"}>
      <Grid item borderBottom={2} borderColor={"#d9d9d9"}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="Candidate Interview Info"
        >
          <CustomTab label="Interviews" {...tabAriaProps(0)} />
          <CustomTab label="Assessment" {...tabAriaProps(1)} />
          <CustomTab label="Application History" {...tabAriaProps(2)} />
        </Tabs>
      </Grid>
      <Grid container item p={2}>
        <TabPanel
          tabValue={tabValue}
          index={0}
          container
          {...tabPanelAriaProps(0)}
        >
          <CandidateInterview candidate={candidate} job={job} />
        </TabPanel>
        <TabPanel
          tabValue={tabValue}
          index={1}
          container
          {...tabPanelAriaProps(1)}
        >
          <CandidateAssessment candidate={candidate} job={job} />
        </TabPanel>
        <TabPanel
          tabValue={tabValue}
          index={2}
          container
          {...tabPanelAriaProps(2)}
        >
          <Timeline candidateId={(candidate?.id || 0).toString()} />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default Container;
